<template lang="html">
    <div class="qyj">
        <!-- banner -->
        <div class="qyj-banner">
            <!-- <img width="100%" src="https://static.qyjmed.com/webSite/aboutUs/qyj/qyj-bg.png" alt=""> -->
        </div>
        <!-- 诞生 -->
        <div class="born">
            <div class="container">
                <div data-wow-delay="1s" class="wow bounceInLeft born-content">
                    <h2>全医佳的诞生</h2>
                    <p>全医佳成立于2015年，是中国为完善医疗设备服务市场而搭建的综合性纯服务类电商平台，也是国内专业的医疗设备服务电商平台。</p>
                    <p>我们拥有一支由优秀的职业经理人组成的管理团队，曾成功运营过医疗设备服务管理行业的上市公司。在2015年，全医佳国内基金公司注资，率先构建战略合作型服务平台，不断向医疗设备服务业纵深化发展。</p>
                    <p>全医佳与近三千家医院、3000多家服务商、各省级医疗检测机构及中国医学装备协会等组织结为深度战略合作关系，共建一个联盟性的行业生态链，真正实现海量行业信息资源的完美整合。未来，全医佳将致力于成为医疗设备服务行业的领航者。 </p>
                </div>
                <div class="born-img">
                    <img src="https://static.qyjmed.com/webSite/aboutUs/qyj/born-img.png" alt="">
                    <img data-wow-delay="1s" class="wow bounceInRight" src="https://static.qyjmed.com/webSite/aboutUs/qyj/born-img1.png" alt="">
                </div>
            </div>
        </div>
        <!-- 客户服务 -->
        <div class="server">
            <div class="container">
                <div class="server-content">
                    <h2>客户服务</h2>
                    <p>CUSTOMER SERVICE</p>
                    <ul data-wow-delay="1s" class="wow bounceInLeft">
                        <li>
                            <div class="server-box">
                                <i>
                                    <img src="https://static.qyjmed.com/webSite/aboutUs/qyj/span.png" alt="">
                                </i>7*24服务响应体制
                            </div>
                        </li>
                        <li>
                            <div class="server-box">
                                <i>
                                    <img src="https://static.qyjmed.com/webSite/aboutUs/qyj/span.png" alt="">
                                </i>专设呼叫中心与客户服务中心
                            </div>
                        </li>
                        <li>
                            <div class="server-box">
                                <i>
                                    <img src="https://static.qyjmed.com/webSite/aboutUs/qyj/span.png" alt="">
                                </i>项目跟踪与任务预警体
                            </div>
                        </li>
                        <li>
                            <div class="server-box">
                                <i>
                                    <img src="https://static.qyjmed.com/webSite/aboutUs/qyj/span.png" alt="">
                                </i>客服现场远程监控系统
                            </div>
                        </li>
                        <li>
                            <div class="server-box">
                                <i>
                                    <img src="https://static.qyjmed.com/webSite/aboutUs/qyj/span.png" alt="">
                                </i>工程师动态调度系统
                            </div>
                        </li>
                        <li>
                            <div class="server-box">
                                <i>
                                    <img src="https://static.qyjmed.com/webSite/aboutUs/qyj/span.png" alt="">
                                </i>客服关系管理系统（建设）
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="server-img">
                    <img src="https://static.qyjmed.com/webSite/aboutUs/qyj/qyj-server.png" alt="">
                </div>
            </div>
        </div>
        <!-- 维保服务 -->
        <div class="maintenance">
            <div class="container">
                <h2>维保服务</h2>
                <p>
                    <img src="https://static.qyjmed.com/webSite/index/line-light.png" alt="">
                </p>
                <div class="maintent">
                    <div class="maintent-box">
                        <img src="https://static.qyjmed.com/webSite/aboutUs/qyj/weibao1.png" alt="">
                        <p class="maintent-p">打造全新品牌</p>
                        <p>提供最满意的服务</p>
                    </div>
                    <div class="maintent-box">
                        <img src="https://static.qyjmed.com/webSite/aboutUs/qyj/weibao2.png" alt="">
                        <p class="maintent-p">加强渠道</p>
                        <p>实现业务高速增长</p>
                    </div>
                    <div class="maintent-box">
                        <img src="https://static.qyjmed.com/webSite/aboutUs/qyj/weibao3.png" alt="">
                        <p class="maintent-p">一体化的</p>
                        <p>业务支撑平台系统</p>
                    </div>
                    <div class="maintent-box">
                        <img src="https://static.qyjmed.com/webSite/aboutUs/qyj/weibao4.png" alt="">
                        <p class="maintent-p">利用互联网</p>
                        <p>实现客户良好体验</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 服务承诺 -->
        <div class="promise">
            <div class="container">
                <div data-wow-delay="1s" class="wow bounceInLeft promise-content">
                    <h2>服务承诺</h2>
                    <p>微笑：面对客户时刻保持笑容；</p>
                    <p>效率：7x24 小时电话接听、半小时电话响应、24小时现场服务；</p>
                    <p>跟踪：接报建档、现场关注、3天回访、月度跟踪；</p>
                    <p>诚信：信守承诺、满意服务、关注客户、时刻待命；</p>
                    <p>安全：作业安全、场地安全、产品安全、使用安全；</p>
                </div>
                <div class="promise-img">
                    <img src="https://static.qyjmed.com/webSite/aboutUs/qyj/qyj-promise.png" alt="">
                </div>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
import {WOW} from 'wowjs';
export default {
  name: 'HeaderTop',
  mounted() {
      var wow=new WOW({
          live: false
      })
      wow.init()
  },
  components: {
      Foot
  }
}
</script>

<style lang="scss" scoped>
    $h2-size:34px;
    .qyj{
        .qyj-banner{
            margin-top: $highlight-height;
            background: url('https://static.qyjmed.com/webSite/aboutUs/qyj/qyj-bg.png') center;
            height: 562px;
        }
        // 诞生
        .born{
            background: #FAFAFA;
            .container{
                .born-content{
                    width: 650px;
                    display: inline-block;
                    vertical-align: top;
                    h2{
                        font-size: $h2-size;
                        font-weight: bold;
                        color: #262626;
                        margin: 188px 0 100px;
                    }
                    p{
                        font-size: 18px;
                        color:#333;
                        line-height: 36px;
                        text-indent: 2rem;
                        margin-bottom: 10px;
                    }
                }
                .born-img{
                    width: 550px;
                    display: inline-block;
                    img:first-child{
                        margin: 300px 0 116px 50px;
                        position: absolute;
                        z-index: 10;
                    }
                    img:last-child{
                        position: relative;
                        z-index: 9;
                        margin-left: 200px;
                    }

                }
            }
        }
        // 客户服务
        .server{
            .container{
                .server-content{
                    width: 650px;
                    display: inline-block;
                    vertical-align: top;
                    h2{
                        margin:124px 0 28px;
                        font-size: $h2-size;
                    }
                    p{
                        font-size: 26px;
                        color: #BCBCBC;
                        margin-bottom: 75px;
                    }
                    ul{
                        margin-bottom: 100px;
                        li{
                            width: 50%;
                            display: inline-block;
                            .server-box{
                                margin: 30px 0;
                                font-size: 22px;
                                color: #333;
                                i{
                                    img{
                                        margin: -2px 10px 0px 0;
                                        vertical-align: middle;
                                    }
                                }
                            }
                            &:nth-last-child(1),&:nth-last-child(2){
                                width: 100%;
                            }
                        }

                    }
                }
                .server-img{
                    width: 550px;
                    display: inline-block;
                    text-align: right;
                    img{
                        margin: 220px 78px 0 0;
                    }
                }
            }
        }
        // 维保服务
        .maintenance{
            text-align: center;
            background-color: #F6F8FA;
            background-image: url('https://static.qyjmed.com/webSite/aboutUs/qyj/weibao-bg.png');
            height: 700px;
            background-repeat: no-repeat;
            .container{
                h2{
                    font-size: $h2-size;
                    padding-top: 70px;
                }
                p{
                    img{
                        margin: 30px 0 80px;
                    }
                }
                .maintent{
                    div{
                        width: 270px;
                        height: 300px;
                        margin-right: 40px;
                        display: inline-block;
                        background-color: white;
                        vertical-align: top;
                        img{
                            margin-top: 40px;
                        }
                        p{
                            line-height: 30px;
                            color: #333333;
                        }
                        .maintent-p{
                            margin-top: 30px;
                        }
                        &:nth-child(1){
                            img{
                                margin-top: 48px;
                            }
                            .maintent-p{
                                margin-top: 36px;
                            }

                        }
                        &:nth-child(2){
                            img{
                                margin-top: 48px;
                            }
                            .maintent-p{
                                margin-top: 40px;
                            }
                        }
                        &:nth-child(3){
                            img{
                                margin-top: 38px;
                            }
                            .maintent-p{
                                margin-top: 26px;
                            }
                        }
                        &:nth-child(4){
                            margin-right: 0;
                            img{
                                margin-top: 54px;
                            }
                            .maintent-p{
                                margin-top: 42px;
                            }
                        }
                    }
                }
            }
        }
        // 服务承诺
        .promise{
            .container{
                .promise-content{
                    width: 650px;
                    display: inline-block;
                    vertical-align: top;
                    h2{
                        font-size: $h2-size;
                        margin-top: 172px;
                        margin-bottom: 50px;
                    }
                    >p{
                        line-height: 56px;
                        font-size: 16px;
                        &:first-child{
                            margin-top: 50px;
                        }
                    }
                }
                .promise-img{
                    width: 550px;
                    margin-top: 100px;
                    display: inline-block;
                    margin-bottom: 130px;
                }
            }
        }
    }
</style>
